import React from "react";
import { Outlet } from "react-router-dom";


const LandingPageLayout = () => {


    return (
        <>
            <div className="landingpage">
                <Outlet/>
            </div>

        </>
    );
}

export default LandingPageLayout;